module.exports = __webpack_public_path__ + "static/img/cantdisplay-image.0425af4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cantdisplay-image.png
// module id = 156/
// module chunks = 1